import React from 'react'
import Typography from '@material-ui/core/Typography'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Grid from '@material-ui/core/Grid'
import GpsIcon from '@material-ui/icons/GpsFixed'
import { withStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import { Close } from 'mdi-material-ui'
import {
  Speedometer,
  Compass,
  ClockOutline,
  Pound,
  Account,
  CarSports,
} from 'mdi-material-ui'
import Altitude from 'mdi-material-ui/ImageFilterHdr'
import { database } from '../firebase'
import CircularProgress from '@material-ui/core/CircularProgress'

const styles = theme => ({
  root: {
    width: '100%',
    maxHeight: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '16pt',
    marginBottom: '16pt'
  },
  
  telemetryContainer: {paddingTop: '8pt'},
  title: {marginLeft: '16pt'}
})

class RacerDetailView extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      driver: 'Anonymous',
      codriver: 'Anonymous',
      vehicle: 'Unknown',
      shortId: 'N/A',
      firstUpdate: false,
      firstUserUpdate: false,
      speed: 0,
      lat: 0,
      lng: 0,
      altitude: 0,
      heading: 0,
      lastUpdate: new Date()
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps.id !== this.props.id) {
      this.resubscribe()
    }
    if (prevState.uid !== this.state.uid) {
      this.subscribeUser(this.state.uid)
    }
  }

  subscribeUser (uid) {
    this.unsubscribeUser()
    if (uid !== null || uid !== undefined) {
      this.userRef = database.ref('users/' + uid)
      this.userListener = this.userRef.on('value', data => {
        let values = data.val()
        this.setState({
          firstUserUpdate: true,
          driver: (values && values.driver && values.driver.length > 0 && values.driver) || 'Anonymous',
          codriver: (values && values.codriver && values.codriver.length > 0 && values.codriver) || 'Anonymous',
          car: (values && values.vehicle && values.vehicle.length > 0 && values.vehicle) || 'Unknown',
          shortId: (values && values.id && values.id.length > 0 && values.id) || 'N/A'
        })

      })
    }

  }

  unsubscribeUser () {
    if (!(this.userRef === null || this.userRef === undefined)) {
      this.userRef.off('value', this.userListener)
      this.userRef = null
    }
  }

  unsubscribe () {
    if (!(this.ref === null || this.ref === undefined)) {
      this.ref.off('value', this.listener)
      this.ref = null
    }
    this.unsubscribeUser()

  }

  /*
  driver : values.driver,
        codriver : values.uid.codriver,
        car : values.uid.car,
        shortId : values.uid.shortId,
        isCharging : values.battery_data.charging,
        batteryPct : values.battery_data.batteryPct,
        networkOperator : values.network_data.networkOperator,
        simOperator : values.network_data.simOperator,
        signalStrength : values.network_data.signalStrength,
        roaming : values.network_data.roaming,
        product : values.device_node.product

        <ListItem>
                  <ListItemIcon>
                    <Battery/>
                  </ListItemIcon>
                  <ListItemText inset primary={Math.round(this.state.batteryPct * 100) + "%"}
                                secondary="battery percent"/>
                </ListItem>

                <ListItem>
                  <ListItemIcon>
                    <PowerPlug/>
                  </ListItemIcon>
                  <ListItemText inset primary={this.state.isCharging + ""}
                                secondary="is charging"/>
                </ListItem>

                <ListItem>
                  <ListItemIcon>
                    <NetworkStrengthOutline/>
                  </ListItemIcon>
                  <ListItemText inset primary={this.state.signalStrength + "dBm"}
                                secondary="signalStrength"/>
                </ListItem>

                <ListItem>
                  <ListItemText inset primary={this.state.networkOperator}
                                secondary="network operator"/>
                </ListItem>

                <ListItem>
                  <ListItemText inset primary={this.state.simOperator}
                                secondary="sim operator"/>
                </ListItem>

                <ListItem>
                  <ListItemText inset primary={this.state.roaming + ""}
                                secondary="roaming"/>
                </ListItem>

                <ListItem>

                  <ListItemIcon>
                    <Cellphone/>
                  </ListItemIcon>
                  <ListItemText inset primary={this.state.product}
                                secondary="device"/>
                </ListItem>
   */

  resubscribe () {
    this.unsubscribe()

    this.ref = database.ref('tracking/' + this.props.id)

    this.listener = this.ref.on('value', data => {
      let values = data.val()
      if (values !== null){
        this.setState({
          uid: values.userId,
          firstUpdate: true,
          speed: values.speedMS,
          lat: values.lat,
          lng: values.lng,
          heading: values.heading,
          altitude: values.altitude,
          lastUpdate: values && values.timeStamp && values.timeStamp.timeStamp && new Date(values.timeStamp.timeStamp)
        })
      }
    })
  }

  componentDidMount () {
    this.resubscribe()
  }

  componentWillUnmount () {
    this.unsubscribe()
  }

  render () {
    const {classes} = this.props
    return (
      <div className={classes.root}>

      

        <IconButton
            onClick={() => this.props.close()}
            color="inherit"
          >
            <Close/>
          </IconButton>

          <Typography
            className={classes.title}
          
            variant="title">
            Competitor
          </Typography>

         

          <div>
            {!this.state.firstUserUpdate ? (<CircularProgress/>) :
              (<List>
                <ListItem>
                  <ListItemIcon>
                    <Account/>
                  </ListItemIcon>
                  <ListItemText inset
                                primary={this.state.driver}
                                secondary="driver"
                  >


                  </ListItemText>
                </ListItem>
                <ListItem>
                  <ListItemText inset primary={this.state.codriver}
                                secondary="co-driver"/>
                </ListItem>

                <ListItem>
                  <ListItemIcon>
                    <CarSports/>
                  </ListItemIcon>
                  <ListItemText inset primary={this.state.car}
                                secondary="racing car"/>
                </ListItem>


                <ListItem>
                  <ListItemIcon>
                    <Pound/>
                  </ListItemIcon>
                  <ListItemText inset primary={this.state.shortId}
                                secondary="competitor number"/>
                </ListItem>


              </List>)}
          </div>
          <Typography
            className={classes.title}
            align={'left'}
            variant="title">
            Telemetry
          </Typography>
          <div className={classes.telemetryContainer}>
            {!this.state.firstUpdate ? (<CircularProgress/>) :
              (<List>
                <ListItem>
                  <ListItemIcon>
                    <GpsIcon/>
                  </ListItemIcon>
                  <ListItemText inset
                                primary={Number(this.state.lat).toFixed(6)}
                                secondary="latitude"
                  >


                  </ListItemText>
                </ListItem>
                <ListItem>
                  <ListItemText inset primary={Number(this.state.lng).toFixed(6)}
                                secondary="longitude"/>
                </ListItem>

                <ListItem>
                  <ListItemIcon>
                    <Speedometer/>
                  </ListItemIcon>
                  <ListItemText inset primary={Number(this.state.speed * 3.6).toFixed(0)}
                                secondary="speed (km/h)"/>
                </ListItem>

                <ListItem>
                  <ListItemIcon>
                    <Compass/>
                  </ListItemIcon>
                  <ListItemText inset primary={Number(this.state.heading).toFixed(0)}
                                secondary="heading (deg)"/>
                </ListItem>

                <ListItem>
                  <ListItemIcon>
                    <Altitude/>
                  </ListItemIcon>
                  <ListItemText inset primary={Number(this.state.altitude).toFixed(0)}
                                secondary="altitude (m)"/>
                </ListItem>

                <ListItem>
                  <ListItemIcon>
                    <ClockOutline/>
                  </ListItemIcon>
                  <ListItemText inset primary={this.state.lastUpdate.toLocaleString()}
                                secondary="last update"/>
                </ListItem>


              </List>)
            }

          </div>

      
      </div>
    )

  }
}

export default withStyles(styles)(RacerDetailView)


// WEBPACK FOOTER //
// ./src/views/RacerDetailView.js